import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { useFocusVisible } from '@react-aria/interactions';
import { createDataTestId } from '../../utils/test/testIds';
import { LinkBaseRoot } from './LinkBase.styles';
export const LinkBase = React.forwardRef(function LinkBase(_ref, ref) {
  let {
    children,
    testId,
    component = 'a',
    ...restAnchorProps
  } = _ref;
  const {
    isFocusVisible
  } = useFocusVisible();
  const dataTestIdProps = createDataTestId(testId);
  return React.createElement(LinkBaseRoot, _extends({
    as: component
  }, restAnchorProps, dataTestIdProps, {
    ref: ref,
    isFocusVisible: isFocusVisible,
    "data-component": "LinkBase"
  }), children);
});